import axios from '../plugins/axios';

export default {
  loadGroupList() {
    const url = process.env.VUE_APP_HIWORKS_GROUP_API + `/self/groups`;

    return axios.get(url);
  },
  setGroupVisible(groupId) {
    const url = process.env.VUE_APP_HIWORKS_GROUP_API + `/groups/` + groupId + `/self/star`;

    return axios.patch(url);
  },
};
